<template>
	<!-- Start Navbar -->
	<nav
		class="navbar navbar-expand-lg mx-0 align-items-center d-flex justify-content-between fixed-top custom-nav sticky-header"
		bg-variant="dark"
	>
		<div
			style="position: relative;"
			class="w-100 mx-1 mx-lg-5 mx-xl-5 py-1 align-items-center d-flex justify-content-center justify-content-lg-between justify-content-xl-between"
		>
			<!-- Hamburger Button - Mobile -->
			<div class="header_btn">
				<button
					v-b-toggle.sidebar-backdrop
					class="navbar-toggler ml-2 p-0"
					type="button"
					@click="showMobileMenu"
				>
					<i :class="{
						'mdi mdi-menu': !isMobileMenuOpened,
						'mdi mdi-close': isMobileMenuOpened,
					}"></i>
				</button>
			</div>
			<!-- End Hamburger Button - Mobile -->
			<!-- LOGO -->
			<router-link class="navbar-brand brand-logo mr-0 mr-lg-4 mr-xl-4 mx-sm-auto" to="/">
				<img
					src="@assetsImages/logo/PSHeaderLogo.svg"
					class="img-fluid logo-small-screen"
					alt=""
					@click="pslogoClickHandler"
				/>
				<!-- <img
					src="../assets/images/logo/PSLogo-Desktop.png"
					class="img-fluid logo-light"
					alt=""
				/> -->
				<img
					src="@assetsImages/logo/PSHeaderLogo.svg"
					class="img-fluid logo-dark"
					alt=""
					@click="pslogoClickHandler"
				/>
			</router-link>

			<!-- Sidebar Nav for Mobile -->
			<!-- <b-sidebar
				id="sidebar-backdrop"
				sidebar-class="sidebar-background"
				bg-variant="dark"
				text-variant="light"
				backdrop
				shadow
				left
			>
				<div class="px-3 py-2">
					<div>
						<ul class="navbar-nav navbar-center" id="mySidenav">

							<li class="nav-item">
								<router-link class="nav-link yellow-link" to="/blog"
									>My Daily Cyber</router-link
								>
							</li>
							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" data-toggle="dropdown"
									>Courses</a
								>
								<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
									<li class="nav-item">
										<router-link class="nav-link" to="/courses-encitebb"
											>CMMC Level 1</router-link
										>
									</li>
									<li class="nav-item">
										<router-link class="nav-link" to="/courses-encite"
											>CMMC Level 2</router-link
										>
									</li>
									<li class="nav-item">
										<router-link class="nav-link" to="/courses-encitefoci"
											>FOCI</router-link
										>
									</li>
								</ul>
							</li>

							<li class="nav-item">
								<router-link class="nav-link" to="/events">Events</router-link>
							</li>

							<li class="nav-item dropdown">
								<a
									href="/#/partners"
									class="nav-link dropdown-toggle"
									data-toggle="dropdown"
									>Partners</a
								>

								<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
									<li class="nav-item">
										<router-link class="nav-link" to="/about-cmmc"
											>CMMC</router-link
										>
									</li>
									<li class="nav-item" v-if="!isIndividual">
										<router-link class="nav-link" to="/mep">MEP</router-link>
									</li>
									<li class="nav-item" v-if="!isIndividual">
										<router-link
											class="nav-link"
											to="/small-business-administration"
											>SBA</router-link
										>
									</li>
									<li class="nav-item" v-if="!isIndividual">
										<router-link class="nav-link" to="/pilot-program"
											>MPP Pilot</router-link
										>
									</li>
								</ul>
							</li>

							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" data-toggle="dropdown"
									>Info Hub</a
								>
								<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
									<li class="nav-item">
										<router-link class="nav-link" to="/news"
											>Latest News</router-link
										>
									</li>

									<li class="nav-item">
										<router-link class="nav-link" to="/white-papers"
											>White Papers</router-link
										>
									</li>

									<li class="nav-item">
										<router-link class="nav-link" to="/policy-corner"
											>Policy Corner</router-link
										>
									</li>
								</ul>
							</li>

							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" data-toggle="dropdown"
									>Resources</a
								>
								<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
									<li class="nav-item">
										<router-link
											class="nav-link"
											to="/cyber-readiness-check"
											v-if="!isIndividual"
											>Cyber Readiness Check</router-link
										>
									</li>
									<li class="nav-item">
										<router-link
											class="nav-link"
											to="/cyber-readiness-check-training"
											v-if="!isIndividual"
											>Cyber Readiness Check Training
										</router-link>
									</li>
									<li class="nav-item">
										<router-link class="nav-link" to="/tool-list"
											>Useful Tools</router-link
										>
									</li>
									<li class="nav-item">
										<router-link class="nav-link" to="/useful-links"
											>Useful Links and Resources</router-link
										>
									</li>
								</ul>
							</li>

							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" data-toggle="dropdown"
									>Contact Us</a
								>
								<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
									<li class="nav-item">
										<router-link class="nav-link" to="/contact"
											>Let’s Connect</router-link
										>
									</li>
									<li class="nav-item">
										<router-link class="nav-link" to="/speaker-request"
											>Speaker Request Form</router-link
										>
									</li>
								</ul>
							</li>

							<li class="nav-item dropdown">
								<a class="nav-link dropdown-toggle" data-toggle="dropdown"
									>Profile/Dashboard</a
								>
								<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
									<li class="nav-item">
										<router-link
											class="nav-link"
											to="/my-account"
											v-if="isLoggedIn"
											>My Account</router-link
										>
									</li>
									<li class="nav-item" v-if="isLoggedIn">
										<a href="/dashboard">My Dashboard </a>
									</li>
									<li class="nav-item" v-if="!isLoggedIn">
										<router-link class="nav-link" to="/signup"
											>Sign Up</router-link
										>
									</li>
									<li class="nav-item" v-if="!isLoggedIn">
										<router-link class="nav-link" to="/login"
											>Login</router-link
										>
									</li>
									<li class="nav-item" v-if="isLoggedIn">
										<router-link class="nav-link" to="/logout"
											>Logout</router-link
										>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			</b-sidebar> -->
			<!-- End Sidebar Nav for Mobile -->

			<!-- Full Width Top Nav Bar -->
			<div
				class="navbar-collapse collapse justify-content-end"
				id="navbarCollapse"
			>
				<ul class="navbar-nav navbar-center" id="mySidenav">
					<!-- Home -->
					<li class="nav-item">
						<a class="nav-link menu-item" @click.stop="(e) => menuItemAnchorTagClickHandler(e)" name="Cyber Corner" href="/#/cyber-corner">
							Cyber Corner
						</a>
					</li>
					<!-- Courses Or Videos -->
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle menu-item" name="Courses/Videos" data-toggle="dropdown"
							>Courses/Videos</a
						>
						<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
							<!-- NOTE: DO NOT DELETE THE COMMENTED OUT LINKS BELOW. THEY ARE TEMPORARILY COMMENTED OUT AND WILL BE UNCOMMENTED SOON -->
							<!-- <li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/courses-encitebb"
									>CMMC Level 1</a
								>
							</li>

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/courses-encite"
									>CMMC Level 2</a
								>
							</li> 

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => setAnnouncementText('CMMC Level 3')"
									>CMMC Level 3</a
								>
							</li>

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/courses-encitefoci"
									>FOCI</a
								>
							</li> -->

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/online-courses"
									>Online Courses</a>
							</li>

							<!-- <li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/pillars-of-knowledge"
									>Pillars of Knowledge</a>
							</li> -->

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/information-videos"
									>Informational Videos</a>
							</li>
						</ul>
					</li>
					<!-- Training -->
					<!-- <li class="nav-item">
            <router-link class="nav-link" to="/courses-encite"
              >Courses</router-link
            >
          </li> -->
		  			<!-- Events -->
					<li class="nav-item">
						<a class="nav-link menu-item" @click.stop="(e) => menuItemAnchorTagClickHandler(e)" name="Events" href="/#/events">
							Events
						</a>
					</li>
					<!-- TEMPORARILY REMOVE THE PARTNERS MENU -->
					<!-- Partners -->
					<!-- <li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle menu-item" name="Partners" data-toggle="dropdown"
							>Partners</a
						>
						<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/partners"
									>Our Partners</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/about-cmmc"
									>CMMC</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/mep"
									>MEP</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/small-business-administration"
									>SBA</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/pilot-program"
									>MPP Pilot</a
								>
							</li>
						</ul>
					</li> -->
					<!-- Info Hub -->
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle menu-item" name="Info Hub" data-toggle="dropdown"
							>Info Hub</a
						>
						<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
							<!-- <li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/news"
									>Latest News</a
								>
							</li> -->

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/white-papers"
									>White Papers</a
								>
							</li>
							<!-- <li class="nav-item">
                <router-link class="nav-link" to="/training-videos"
                  >Video Tips</router-link
                >
              </li> -->
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/policy-corner"
									>Policy Corner</a
								>
							</li>

							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/client-templates"
									>Client Templates</a>
							</li>
						</ul>
					</li>
					<!-- Resources -->
					<li class="nav-item dropdown">
						<a class="nav-link dropdown-toggle menu-item" name="Resources" data-toggle="dropdown"
							>Useful Tools</a
						>
						<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/cyber-readiness-check"
									>Cyber Self Assessments</a
								>
							</li>
							<!-- <li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/cyber-readiness-check-training"
									>Cyber Readiness Training</a
								>
							</li> -->
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/tool-list"
									>Products & Services</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/useful-links"
									>Useful Links & Resources</a
								>
							</li>
						</ul>
					</li>
					<!-- Contact Us -->
					<li class="nav-item">
						<a class="nav-link menu-item" @click.stop="(e) => menuItemAnchorTagClickHandler(e)" name="Speaker Request" href="/#/speaker-request"
							>Speaker Request</a
						>
						<!-- <a class="nav-link dropdown-toggle menu-item" name="Contact Us" data-toggle="dropdown"
							>Contact Us</a
						>
						<ul class="nav-bar submenu dropdown-menu list-unstyled p-0">
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/contact"
									>Let’s Connect</a
								>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/speaker-request"
									>Speaker Request Form</a
								>
							</li>
						</ul> -->
					</li>
					<!-- Dashboard -->
					<li class="nav-item dropdown">
						<a class="nav-link menu-item" name="Sign In/Register" data-toggle="dropdown" @click.stop="!isLoggedIn && ((e) => menuItemAnchorTagClickHandler(e))" :href="!isLoggedIn && '/#/login'"
							>{{ loginMenuTabTitle }}</a
						>
						<ul v-if="isLoggedIn" class="nav-bar submenu dropdown-menu list-unstyled p-0">
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/my-account"
									>User Profile</a
								>
							</li>
							<li class="nav-item">
								<!-- <router-link class="nav-link" to="/dashboard">Dashboard</router-link> -->
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/dashboard"
									>My Dashboard </a
								>
							</li>
							<!-- <li class="nav-item" v-if="!isLoggedIn">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/signup"
									>Sign Up</a
								>
							</li>
							<li class="nav-item" v-if="!isLoggedIn">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/login"
									>Login</a
								>
							</li> -->
							<li class="nav-item">
								<a class="nav-link" @click.stop="(e) => anchorTagClickHandler(e)" href="/#/logout"
									>Logout</a
								>
							</li>
						</ul>
					</li>
				</ul>
				<div class="menu-close-btn">
					<i class="mdi mdi-close-circle-outline"></i>
				</div>
			</div>
			<!-- End Full Width Top Nav Bar -->
		</div>
	</nav>
	<!-- End Navbar -->
</template>
<script>
import {
	isInOrganization,
	isOrganizationMember,
} from "../utils/authentication";
import {
	EventBus,
} from "../utils/eventBus";
export default {
	name: "template_header",
	data() {
		return {
			isIndividual: false,
			isDailyCyberActive: false,
		};
	},
	props: {
		isMobileMenuOpened: {
			type: Boolean,
			default: false,
		}
	},
	created() {
		EventBus.$on("activate-indicated-menu-item", this.activateNewIndicatedSelectMenuItem);
	},
	mounted() {
		const selectedMenuItem = localStorage.getItem('selected-menu-item');
		if(selectedMenuItem) {
			this.selectMenuItem(selectedMenuItem);
		}
	},
	computed: {
		isLoggedIn() {
			if (this.$store.state.isLoggedIn) {
				if (!isInOrganization()) {
					this.isIndividual = true;
				} else {
					this.isIndividual = false;
				}
			} else {
				this.isIndividual = false;
			}
			this.$emit("set-user-authentication", { isLoggedIn: this.$store.state.isLoggedIn, isIndividual: this.isIndividual });
			return this.$store.state.isLoggedIn;
		},
		loginMenuTabTitle() {
			return this.isLoggedIn ? 'My Account' : 'Sign In/Register';
		}
	},
	methods: {
		showMobileMenu() {
			this.isMobileMenuOpened = !this.isMobileMenuOpened;
			this.$emit("open-mobile-menu", this.isMobileMenuOpened);
		},
		selectMenuItem(menuItemName){
			const menuItemsByName = document.getElementsByName(menuItemName);
			const activeMenuItem = Array.from(menuItemsByName)[0];
			this.addMenuItemActiveClass(activeMenuItem, menuItemName);
		},
		activateNewIndicatedSelectMenuItem(menuItemName){
			this.removeMenuItemActiveClass();
			this.selectMenuItem(menuItemName);
		},
		removeMenuItemActiveClass(event) {
			if(event) {
				this.isDailyCyberActive = event.target.name === "Cyber Corner";
			}
			localStorage.removeItem('selected-menu-item');
			this.$emit("send-active-mobile-menu-item", null);
			const menuItemClassElements = document.getElementsByClassName('menu-item');
			const mentItemClassList = Array.from(menuItemClassElements);
			const elementWithActiveClass = mentItemClassList.find((element) => element.className.indexOf('router-link-exact-active') > -1);
			if(elementWithActiveClass) {
				elementWithActiveClass.classList.remove('router-link-exact-active', 'router-link-active');
			}
		},
		addMenuItemActiveClass(menuItem, menuItemName) {
			menuItem.classList.add('router-link-exact-active', 'router-link-active');
			this.$emit("send-active-mobile-menu-item", menuItemName);
		},
		menuItemAnchorTagClickHandler(event) {
			this.removeMenuItemActiveClass(event);
			const menuItem = event.target;
			const menuItemName = menuItem.name;
			this.addMenuItemActiveClass(menuItem, menuItemName);
			localStorage.setItem("selected-menu-item", menuItemName);
		},
		anchorTagClickHandler(event) {
			this.removeMenuItemActiveClass(event);
			const menuListElement = event.target.parentElement.parentElement.parentElement;
			const menuItem = menuListElement.firstChild;
			const menuItemName = menuItem.name;
			this.addMenuItemActiveClass(menuItem, menuItemName);
			localStorage.setItem("selected-menu-item", menuItemName);
		},
		setAnnouncementText(subject) {
			this.$emit("send-announcement-text", subject);
		},
		pslogoClickHandler(event) {
			EventBus.$emit("restore-back-to-wheel");
			this.removeMenuItemActiveClass(event);
		}
	},
	beforeDestroy() {
		EventBus.$off("activate-indicated-menu-item");
	},
    watch: {
      $route: {
        handler(to) {
          if (to.path !== '/login') {
			EventBus.$off("redirect-to-encite-lms-courses");
		  }
        }
      }
    }
};
</script>

<style scoped>
.dropdown-menu {
	min-width: 10rem;
	width: max-content;
}
.btn-primary {
	font-weight: 400;
	color: #fff;
	background-color: #f2b636;
	border-color: #f2b636;
}

.custom-nav.sticky-header .navbar-nav li a {
	color: #fff;
	font-style: "Rajdhani" !important;
	font-weight: 600;
	font-size: clamp(0.6rem, 1.5vw, 1rem);
}
.custom-nav .navbar-nav .submenu li a,
.custom-nav.sticky-header .navbar-nav .submenu li a {
	font-family: "Rajdhani" !important;
}
.custom-nav.sticky-header .navbar-nav li button {
	color: #fff !important;
	background-color: #314584;
	border-color: #314584;
}
.navbar-expand-lg .navbar-nav {
	align-items: flex-start;
}

.dropdown-toggle {
	cursor: pointer;
}

.yellow-link {
	color: #f2b636 !important;
	font-weight: 600;
}

.custom-nav.sticky-header {
	background-color: #001426 !important;
	color: #fff !important;
	z-index: 1001;
}

.navbar-brand {
	min-height: 32px;
	min-width: 60px;
}

@media (max-width: 991px) {
	.navbar-toggler i {
		font-size: 28px;
		color: #fff;
	}
}
</style>
